import { FormattedMessage } from 'react-intl';
import { Link, Navigate } from 'react-router-dom';
import { Box, Button, Heading, VStack } from '@chakra-ui/react';
import useOrgsData from '../../../data/useOrgsData';
import {
  DataHandlerFeedback,
  hasDataHandlerFeedBack,
} from '../../../utils/dataHandler';
import { pathOrg } from '../../utils/path';
import RedLight from '../../../svg/red-light.svg?react';

export default function PageDashboard() {
  const orgsDataHandler = useOrgsData();

  if (!orgsDataHandler.data || hasDataHandlerFeedBack(orgsDataHandler)) {
    return <DataHandlerFeedback dataHandlersParam={orgsDataHandler} />;
  }
  if (orgsDataHandler.data.length === 0) {
    return (
      <VStack
        overflowY="auto"
        px={4}
        pt={8}
        alignItems="center"
        justifyContent="flex-start"
        flexGrow={1}
        w="full"
        h="100vh"
        bg="white"
      >
        <VStack
          spacing={4}
          alignItems="center"
          justifyContent="center"
          maxW="440px"
        >
          <Box height="215px" my={2}>
            <RedLight height="100%" width="100%" />
          </Box>
          <Heading size="xl" as="h1" textAlign="center">
            <FormattedMessage
              defaultMessage="It’s time to update your Mooven subscription."
              id="tGjOUQ"
            />
          </Heading>
          <Box fontSize="md" textAlign="center">
            <FormattedMessage
              defaultMessage="Your Mooven subscription has expired. To better understand your projects, view the performance of your sites and the impact you may be having, get in contact with Mooven."
              id="ndOXXj"
            />
          </Box>
          <VStack spacing={2} w="full">
            <Box fontSize="sm" textAlign="center">
              <FormattedMessage
                defaultMessage="US: +1 650 250 2600"
                id="oBD0+U"
              />
            </Box>
            <Box fontSize="sm" textAlign="center">
              <FormattedMessage defaultMessage="AU: 1800 841 854" id="H+iyLb" />
            </Box>
            <Box fontSize="sm" textAlign="center">
              <FormattedMessage defaultMessage="NZ: 0800 806 766" id="DfwWuc" />
            </Box>
            <Box fontSize="sm" textAlign="center">
              <FormattedMessage defaultMessage="sales@mooven.com" id="odDQDy" />
            </Box>
          </VStack>
          <Button
            as={Link}
            variant="solid"
            bg="green.400"
            size="xs"
            to="mailto:rkrctuz0@mooven.intercom-mail.com"
            id="intercom-activator"
          >
            <FormattedMessage defaultMessage="Book a meeting" id="qOXENr" />
          </Button>
        </VStack>
      </VStack>
    );
  }

  const lastSelectedOrgId = localStorage.getItem('last-project-selected');
  const hasOrgForLastSelectedId =
    lastSelectedOrgId !== null &&
    orgsDataHandler.data.some((p) => `${p.insightId}` === lastSelectedOrgId);

  return (
    <Navigate
      to={pathOrg({
        orgId: hasOrgForLastSelectedId
          ? lastSelectedOrgId
          : orgsDataHandler.data[0].insightId.toString(),
      })}
      replace
    />
  );
}
